(function () {
    'use strict';

    function wizardProgress($log) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/wizardProgress.html',
            scope: {
                numberOfSteps: '=',
                title: '@'
            },
            link: function (scope, element, attrs) {
                if (scope.numberOfSteps > 4) {
                    throw Error('wizardProgress only supports up to 4 steps');
                }

                var defaultColumnSizes = {
                    2: 6,
                    3: 4,
                    4: 3
                };

                scope.currentStepIndex = 0;
                scope.stepColumnSize = defaultColumnSizes[scope.numberOfSteps];

                scope.getNumber = function (num) {
                    return new Array(num);
                }
            }
        };
    }

    wizardProgress.$inject = [];

    angular.module('ecap.common').directive('wizardProgress', wizardProgress);
})();